export default {
      id: "location-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "assets/icons/icon-sprite.svg#location-usage",
      toString: function () {
        return this.url;
      }
    }